import { InjectionToken, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { StaticPropertyFormComponent } from './components';

export interface PropertyForm {
  id: string;
  title: string;
  component: Type<StaticPropertyFormComponent>;
}

export const PROPERTY_FORMS = new InjectionToken<PropertyForm[]>('PROPERTY_FORMS');

export interface DimensionElement {
  id: string;
  title: string;
  parentId?: string | null;
}

export type DimensionElementLoader = (
  dimensionId: string
) => Promise<DimensionElement[]> | Observable<DimensionElement[]>;

export const DIMENSION_ELEMENT_LOADER = new InjectionToken<DimensionElementLoader>('DIMENSION_ELEMENT_LOADER');
